import { Injectable } from '@angular/core';

import type { ILandingPage } from 'src/pages/layouts/entities/types';

@Injectable({
    providedIn: 'root',
})
export class PageDataService {
    private pageData: ILandingPage;

    public getData(): ILandingPage | null {
        if (this.pageData) {
            return this.pageData;
        }

        return null;
    }

    public setData(data: ILandingPage) {
        this.pageData = data;
    }
}
